import { PartnerSearchResultType } from '../constants.esm.js';

var LEARN_MORE_ABOUT_SOLUTIONS_URL = 'https://partner.microsoft.com/en-US/partnership/solutions-partner';
var designationItems = [
    {
        title: 'Business applications',
        description: 'Experts at delivering solutions with Dynamics 365 and Power Platform​.',
        navigateOptions: {
            type: 'marketplacePartnerSuggestion',
            query: {
                value: 'BAGCompetency',
                text: 'BAGCompetency',
                type: PartnerSearchResultType.Designation.toString()
            }
        }
    },
    {
        title: 'Data + AI (Azure)',
        description: 'Experts at helping customers build analytics and AI solutions​.',
        navigateOptions: {
            type: 'marketplacePartnerSuggestion',
            query: {
                value: 'AzureDataAICompetency',
                text: 'AzureDataAICompetency',
                type: PartnerSearchResultType.Designation.toString()
            }
        }
    },
    {
        title: 'Digital + app innovation (Azure)',
        description: 'Experts at helping customers build analytics and AI solutions​.',
        navigateOptions: {
            type: 'marketplacePartnerSuggestion',
            query: {
                value: 'AzureDigiAppCompetency',
                text: 'AzureDigiAppCompetency',
                type: PartnerSearchResultType.Designation.toString()
            }
        }
    },
    {
        title: 'Infrastructure (Azure)',
        description: 'Experts at helping customers migrate key infrastructure workloads.',
        navigateOptions: {
            type: 'marketplacePartnerSuggestion',
            query: {
                value: 'AzureInfraCompetency',
                text: 'AzureInfraCompetency',
                type: PartnerSearchResultType.Designation.toString()
            }
        }
    },
    {
        title: 'Modern work',
        description: 'Experts at helping customers boost productivity and shift to hybrid work.',
        navigateOptions: {
            type: 'marketplacePartnerSuggestion',
            query: {
                value: 'ModernCompetency',
                text: 'ModernCompetency',
                type: PartnerSearchResultType.Designation.toString()
            }
        }
    },
    {
        title: 'Security',
        description: 'Experts at safeguarding customers with integrated security, compliance, and identity solutions​.',
        navigateOptions: {
            type: 'marketplacePartnerSuggestion',
            query: {
                value: 'SecurityCompetency',
                text: 'SecurityCompetency',
                type: PartnerSearchResultType.Designation.toString()
            }
        }
    }
];

export { LEARN_MORE_ABOUT_SOLUTIONS_URL, designationItems };
